/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { CoursesTypes, CourseState } from './types';

const INITIAL_STATE: CourseState = {
  course: {
    id: 0,
    description: '',
    created_at: '',
    name: '',
    status: false,
    updated_at: '',
    topics: [],
    last_class: {
      progression: 0,
      total_aula: 0,
      last_class: {
        nome: '',
        url_video: '',
      },
    },
    lessons: [],
    steps_completed: [],
  },
  request: {
    get_course: {
      loading: false,
      loaded: false,
      error: false,
    },
    mark_as_done: {
      loading: false,
      loaded: false,
      error: false,
    },
    start_course: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};
const reducer: Reducer<CourseState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case CoursesTypes.GET_COURSE_REQUEST:
        draft.request.get_course = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case CoursesTypes.GET_COURSE_SUCCESS:
        draft.course = result?.data?.cursos?.curso;
        draft.request.get_course = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case CoursesTypes.GET_COURSE_FAILURE:
        draft.request.get_course = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case CoursesTypes.MARK_AS_DONE_REQUEST:
        draft.request.mark_as_done = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case CoursesTypes.MARK_AS_DONE_SUCCESS:
        window.location.href = '/curso';
        draft.request.mark_as_done = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case CoursesTypes.MARK_AS_DONE_FAILURE:
        draft.request.mark_as_done = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case CoursesTypes.GET_START_COURSE_REQUEST:
        draft.request.start_course = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case CoursesTypes.GET_START_COURSE_SUCCESS:
        window.location.href = '/curso';
        draft.request.start_course = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case CoursesTypes.GET_START_COURSE_FAILURE:
        draft.request.start_course = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
